import { useState, useEffect } from 'react';
import api from '../utils/api';
import { StatCard, Card, CardHeader, fmt, Badge, PageHeader, Table } from '../components/ui';
import { TrendingUp, TrendingDown, Activity, DollarSign, ArrowUpRight, ArrowDownRight } from 'lucide-react';

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get('/transactions/dashboard').then(r => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <div style={{ padding: 60, textAlign: 'center', color: '#94a3b8' }}>Loading…</div>;

  const { buys, sells, recent, top_customers } = data;
  const pnl = parseFloat(sells.total_pnl || 0);

  return (
    <div>
      <PageHeader title="Dashboard" subtitle="Portfolio summary & recent activity" />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 16, marginBottom: 24 }}>
        <StatCard label="Total Buy Trades" value={buys.count} sub={fmt(buys.total) + ' invested'} Icon={TrendingUp} color="#3b82f6" />
        <StatCard label="Total Sell Trades" value={sells.count} sub={fmt(sells.total) + ' proceeds'} Icon={TrendingDown} color="#8b5cf6" />
        <StatCard label="Realized P&L" value={fmt(pnl)} sub={pnl >= 0 ? 'Overall profit' : 'Overall loss'} Icon={pnl >= 0 ? ArrowUpRight : ArrowDownRight} color={pnl >= 0 ? '#059669' : '#dc2626'} />
        <StatCard label="Total Volume" value={parseInt(buys.count || 0) + parseInt(sells.count || 0)} sub="All transactions" Icon={Activity} color="#d97706" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
        {/* Recent Transactions */}
        <Card>
          <CardHeader title="Recent Transactions" subtitle="Last 5 entries" />
          <Table
            headers={['Type', 'Customer', 'Script', 'Qty', 'Price', 'Net']}
            rows={(recent || []).map(t => [
              <Badge color={t.transaction_type === 'BUY' ? 'green' : 'red'}>{t.transaction_type}</Badge>,
              <div><div style={{ fontWeight: 600 }}>{t.customer_code}</div><div style={{ fontSize: 11, color: '#64748b' }}>{t.customer_name}</div></div>,
              t.script_name,
              t.quantity,
              fmt(t.price),
              <strong style={{ color: t.transaction_type === 'BUY' ? '#1d4ed8' : '#dc2626' }}>{fmt(t.net_amount)}</strong>
            ])}
            empty="No transactions yet"
          />
        </Card>

        {/* Top Customers */}
        <Card>
          <CardHeader title="Top Customers" subtitle="By number of trades" />
          <Table
            headers={['Customer', 'Trades', 'Buy Total', 'P&L']}
            rows={(top_customers || []).map(c => {
              const pl = parseFloat(c.total_pnl || 0);
              return [
                <div><div style={{ fontWeight: 600 }}>{c.customer_code}</div><div style={{ fontSize: 11, color: '#64748b' }}>{c.customer_name}</div></div>,
                c.trades,
                fmt(c.buy_total),
                <span style={{ color: pl >= 0 ? '#059669' : '#dc2626', fontWeight: 700 }}>{fmt(pl)}</span>
              ];
            })}
            empty="No data"
          />
        </Card>
      </div>
    </div>
  );
}
